<template>
  <div class="container">
    <table class="table table-bordered">
      <thead>
        <tr class="thead-light">
          <th>What services would you like to utilize during the Career Expo?</th>
          <th>Price</th>
          <th>Amount</th>
          <th>Total price</th>
        </tr>
      </thead>
      <tbody>
        <Slider option="extra-employee">
          <ul slot="info">
            <li>
              Your
              <span v-html="stand.option.name" />
              already includes {{stand.option.employees || 0}} employees.
            </li>
          </ul>
        </Slider>
        <Slider option="extra-table">
          <ul slot="info">
            <li>
              Your
              <span v-html="stand.option.name" />
              already includes {{stand.option.tables || 0}} tables.
            </li>
          </ul>
        </Slider>
        <Slider option="extra-barstool">
          <ul slot="info">
            <li>
              Your
              <span v-html="stand.option.name" />
              already includes {{stand.option.barstools || 0}} barstools.
            </li>
          </ul>
        </Slider>
      </tbody>
    </table>
    <router-link to="/subscribe/speed-dates" v-if="$store.getters.getOption('speed-dates')">
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link to="/subscribe/package-selection" v-else>
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link
      to="/subscribe/interviewing-days-options"
      v-if="$store.getters.hasEvent('interviewing-days')"
    >
      <button class="btn btn-primary">Next</button>
    </router-link>
    <router-link to="/subscribe/overview" v-else>
      <button class="btn btn-primary">Next</button>
    </router-link>
  </div>
</template>

<script>
import Slider from "@/components/Slider.vue";
import YesNo from "@/components/YesNo.vue";

export default {
  name: "career-expo-options",
  components: {
    Slider,
    YesNo
  },
  computed: {
    subscriberData() {
      return this.$store.state.subscriberData;
    },
    stand() {
      return (
        this.$store.getters.getOption("normal-stand") ||
        this.$store.getters.getOption("small-stand")
      );
    }
  }
};
</script>
